import { render } from "./BranchSelector.vue?vue&type=template&id=c44d265c"
import script from "./BranchSelector.vue?vue&type=script&lang=js"
export * from "./BranchSelector.vue?vue&type=script&lang=js"

import "./BranchSelector.vue?vue&type=style&index=0&id=c44d265c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__